import React from "react";

export default function Legal() {
  return (
    <main className="pt-32 pb-20 max-w-3xl mx-auto px-6 prose prose-invert" data-testid="legal-page">
      <section>
        <p className="label-luxe text-[#D4AF37] mb-3">Document Legal</p>
        <h1 className="h-display text-5xl text-[#F8F4E6] mb-10">Termeni & Condiții</h1>
        <div className="text-[#A39E8A] space-y-4 leading-relaxed">
          <p>Prin accesarea și utilizarea platformei Johny's Antique Shop, sunteți de acord cu termenii prezenți. Platforma este destinată exclusiv adulților cu capacitate juridică deplină.</p>
          <h3 className="font-serif text-2xl text-[#F8F4E6] mt-8">Comenzi și Plăți</h3>
          <p>Toate prețurile sunt exprimate în EURO și includ TVA. Plățile sunt procesate securizat prin Stripe.</p>
          <h3 className="font-serif text-2xl text-[#F8F4E6] mt-8">Returnări</h3>
          <p>Aveți dreptul să returnați piesa achiziționată în termen de 14 zile, dacă nu prezintă deteriorări față de starea originală.</p>
          <h3 className="font-serif text-2xl text-[#F8F4E6] mt-8">Răspundere</h3>
          <p>Johny's Antique Shop garantează autenticitatea fiecărei piese. În cazul unor inexactități dovedite, oferim rambursare integrală.</p>
        </div>
      </section>
      <section id="privacy" className="mt-24">
        <p className="label-luxe text-[#D4AF37] mb-3">Confidențialitate</p>
        <h2 className="h-display text-4xl text-[#F8F4E6] mb-8">Politica de Confidențialitate</h2>
        <div className="text-[#A39E8A] space-y-4 leading-relaxed">
          <p>Respectăm GDPR și protejăm datele dvs. personale. Informațiile sunt utilizate exclusiv pentru procesarea comenzilor și comunicări de marketing (cu acord prealabil).</p>
          <p>Aveți dreptul să solicitați ștergerea, modificarea sau exportul datelor dumneavoastră prin contact@jhonyantiquesshop.ro.</p>
        </div>
      </section>
    </main>
  );
}
